;(function() {
  'use strict'

  angular.module('core.interactions', [])
})()
